export default __webpack_public_path__ + "static/media/gpu-arrow.6d89694c.svg";